import React, { lazy } from "react";
import ProtectedRoute from "./components/ProtectedRoute";

const Login = lazy(() => import("./components/Login"));
const CreateNewPassword = lazy(() => import("./components/CreateNewPassword"));
const Dashboard = lazy(() => import("./components/Dashboard"));
const Contacts = lazy(() => import("./components/Contacts"));
const Campaigns = lazy(() => import("./components/Campaigns"));
const CampaignDetails = lazy(() => import("./components/CampaignDetails"));
const EditGuest = lazy(() => import("./components/EditGuest"));
const Coldcalling = lazy(() => import("./components/Coldcalling"));
const ShibirProgram = lazy(() => import("./components/ShibirProgram"));
const CampaignCallSevakDetails = lazy(
  () => import("./components/CampaignCallSevakDetails"),
);
const AddEditContacts = lazy(() => import("./components/AddEditContacts"));
const ViewContact = lazy(() => import("./components/ViewContact"));
const HospitalityEvent = lazy(() => import("./components/HospitalityEvent"));
const EventParticipate = lazy(() => import("./components/EventParticipate"));
const DashboardRegistration = lazy(
  () => import("./components/DashboardRegistration"),
);
const DashboardAdmin = lazy(() => import("./components/DashboardAdmin"));
const MemberCoreData = lazy(() => import("./components/MemberCoreData"));
const NotFound = lazy(() => import("./components/NotFound"));
const Unauthorized = lazy(() => import("./components/Unauthorized"));

const routes = [
  // Public routes
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/create-new-password",
    element: <CreateNewPassword />,
  },
  {
    path: "/unauthorized",
    element: <Unauthorized />,
  },

  // Protected routes
  {
    path: "/dashboard",
    element: <ProtectedRoute element={<Dashboard />} />,
  },
  {
    path: "/dashboardRegistration",
    element: <ProtectedRoute element={<DashboardRegistration />} />,
  },
  {
    path: "/dashboardAdmin",
    element: <ProtectedRoute element={<DashboardAdmin />} />,
  },
  // {
  //   path: "/dashboard",
  //   element: <ProtectedRoute element={<DashboardMarketing />} />,
  // },
  {
    path: "/contacts",
    element: <ProtectedRoute element={<Contacts />} />,
  },
  {
    path: "/campaigns",
    element: <ProtectedRoute element={<Campaigns />} />,
  },
  {
    path: "/campaign-details",
    element: <ProtectedRoute element={<CampaignDetails />} />,
  },
  {
    path: "/edit-guest",
    element: <ProtectedRoute element={<EditGuest />} />,
  },
  {
    path: "/cold-calling",
    element: <ProtectedRoute element={<Coldcalling />} />,
  },
  {
    path: "/shibir-program",
    element: <ProtectedRoute element={<ShibirProgram />} />,
  },
  {
    path: "/call-sevak-details",
    element: <ProtectedRoute element={<CampaignCallSevakDetails />} />,
  },
  {
    path: "/add-edit-contacts",
    element: <ProtectedRoute element={<AddEditContacts />} />,
  },
  {
    path: "/view-contact",
    element: <ProtectedRoute element={<ViewContact />} />,
  },
  {
    path: "/add-contact",
    element: <ProtectedRoute element={<AddEditContacts />} />,
  },
  {
    path: "/hospitalityEvent",
    element: <ProtectedRoute element={<HospitalityEvent />} />,
  },
  {
    path: "/Event-Participate",
    element: <ProtectedRoute element={<EventParticipate />} />,
  },
  {
    path: "/memberCore",
    element: <ProtectedRoute element={<MemberCoreData />} />,
  },

  // 404 catch-all
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
